import { contentLibraryServiceClient } from './client';

export type FetchPdfPresignedUrlParams = {
  fileName: string;
  contentType: string;
};

export type FetchPdfPresignedUrlResponse = {
  putUrl: string;
  getUrl: string;
  pdfPath: string;
};

export async function fetchPdfPresignedUrl(params: FetchPdfPresignedUrlParams): Promise<FetchPdfPresignedUrlResponse> {
  return contentLibraryServiceClient.get<FetchPdfPresignedUrlResponse>('/assets/pdf/presigned-url', {
    params: {
      fileName: params.fileName,
      contentType: params.contentType,
    },
  });
}
